import type { XrefCables } from "@/composables/forms/formTypes";
import { GenericUnits } from "@/libs/units/generic";
import { LengthUnits } from "@/libs/units/length";
import { PowerUnits } from "@/libs/units/power";
import { arrayOfInts } from "@/utils/utils";
import type { RenderScenarioExportCols } from "./sizingExportTypes";
import { PercentageUnits } from "@/libs/units/percentage";

export const renderCableCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits,
  maxCables
}) =>
  arrayOfInts(maxCables).flatMap(i => {
    const section = `CABLE ${i + 1}`;
    const cable: XrefCables[number] | undefined = calcs.orderedCables.value[i];
    return [
      {
        section,
        label: "Cable Description",
        targetUnit: null,
        value: calcs.cableCalculations.individual.value[cable?.id]?.cableHeader
      },
      {
        section,
        label: "Cable Width",
        targetUnit: LengthUnits.Inches,
        value: cable?.r_cable?.width_inches,
        disableConversion: true
      },
      {
        section,
        label: "Cable Length",
        targetUnit: targetUnits.largeLengthUnit,
        value: cable?.length_feet
      },
      {
        section,
        label: "Cable Weight",
        targetUnit: targetUnits.massUnit,
        value:
          calcs.cableCalculations.individual.value[cable?.id]?.cableWeightLbs
      },
      {
        section,
        label: "Temperature Rating",
        targetUnit: targetUnits.tempUnit,
        value: cable?.r_cable?.max_temperature_fahrenheit
      },
      {
        section,
        label: "Cable Volts Loss / 1000ft",
        targetUnit: targetUnits.voltageUnit,
        value:
          calcs.cableCalculations.individual.value[cable?.id]
            ?.voltLossPerThousandFTV
      },
      {
        section,
        label: "Cable Power Loss",
        targetUnit: targetUnits.realPowerUnit,
        value: PowerUnits.KiloWatts.toStandardUnit(
          calcs.cableCalculations.individual.value[cable?.id]?.powerLossKW
        )
      },
      {
        section,
        label: "Power Cost $/kW",
        targetUnit: GenericUnits.UnitedStatesDollar,
        value: scenario.parameters.value?.cable_cost_kw_hr_usd
      },
      {
        section,
        label: "Monthly Power Cost $",
        targetUnit: GenericUnits.UnitedStatesDollar,
        value:
          calcs.cableCalculations.individual.value[cable?.id]
            ?.cablePowerCostPerMonthUSD
      },
      {
        section,
        label: "Cable Operating Temperature",
        targetUnit: targetUnits.tempUnit,
        value:
          calcs.cableCalculations.individual.value[cable?.id]
            ?.cableMaxTemperatureF
      },
      {
        section,
        label: "Cable Motor Load",
        targetUnit: PercentageUnits.Percentage,
        value: PercentageUnits.Ratio.toStandardUnit(
          calcs.cableCalculations.individual.value[cable?.id]
            ?.cableMotorLoadRatio
        )
      },
      {
        section,
        label: calcs.isScenarioEspShore.value
          ? "Cable Max Amperage at Operating Temperature"
          : "Cable Max Amperage at Duty Point Temperature",
        targetUnit: targetUnits.currentUnit,
        value:
          calcs.cableCalculations.individual.value[cable?.id]
            ?.maxAmpsAtMaxTemperatureA
      }
    ];
  });
